module.exports = __webpack_public_path__ + "img/uavinfo_bg.8fe79f79.png";